import { jwApi, JwApiError } from './chunk-FDFVITOH.js';
import { require_cookies, cache, events, extractAuthToken } from './chunk-UL2DPD2B.js';
import { config } from './chunk-4JB325EV.js';
import { __toESM } from './chunk-AXCKF2IS.js';

// src/auth/index.ts
var import_cookies = __toESM(require_cookies(), 1);
async function login({
  email,
  password,
  mfaCode,
  rememberMfa
}) {
  const input = {
    email,
    password,
    code: void 0,
    remember_mfa: void 0,
    mfa_signature: void 0
  };
  if (mfaCode) {
    input.code = mfaCode;
    input.remember_mfa = !!rememberMfa;
  } else {
    const mfaSignature = (0, import_cookies.getCookie)(config.get().auth.cookies.mfa.identifier);
    if (mfaSignature) {
      input.mfa_signature = mfaSignature;
    }
  }
  cache.resetTimers();
  let res;
  try {
    res = await jwApi("dashboard-scope", "create", {
      input
    });
  } catch (err) {
    if (err instanceof JwApiError && err.response?.status === 204) {
      (0, import_cookies.deleteCookie)(config.get().auth.cookies.mfa.identifier);
      return "MFA_REQUIRED";
    }
    throw err;
  }
  if (res.json.authentication.mfa && typeof res.json.authentication.mfa === "string") {
    (0, import_cookies.setCookie)(config.get().auth.cookies.mfa.identifier, res.json.authentication.mfa, {
      "Max-Age": config.get().auth.cookies.mfa.ttl
    });
  }
  (0, import_cookies.deleteCookie)(config.get().auth.cookies.authFromAdmin);
  cache.set(res.json, extractAuthToken(res.json));
  return res.json;
}
async function refreshAuth({ signal } = {}) {
  cache.resetTimers();
  const token = cache.getToken();
  if (!token) {
    return;
  }
  const res = await jwApi("dashboard-scope", "read", {}, { signal });
  cache.set(res.json, res.json.authentication.dashboard);
  return res.json;
}
async function logout() {
  cache.clear();
}
var auth = {
  login,
  logout,
  refreshAuth,
  // Only the get function should be exposed publicly
  cache: {
    get: () => cache.get(),
    // For interop with the old companion-lib, we'll temporarily also expose this set method
    set: (...args) => cache.setCacheAndToken(args[0], args[1])
  },
  events
};

export { auth };
